
















































































import { defineComponent, ref, useRouter, useRoute } from '@nuxtjs/composition-api'
import { TargetSpecies } from '@cstweb/commercetools-client'
import ShowFeature from '~/components/global/ShowFeature.vue'
import ErrorsContainer from '~/components/global/errors/Errors.vue'

// Composables
import useEcommerceAnalytics from '~/composables/analytics/useEcommerceAnalytics'
import { Errors } from '~/composables/errors/useErrors'
import { useI18n } from '~/composables/i18n'
import { usePanelBuilder } from '~/composables/signalstar/usePanelBuilder'

const targetOptions = [
  { value: 'H', label: 'Human' },
  { value: 'M', label: 'Mouse' },
] as const

export default defineComponent({
  components: { ShowFeature, ErrorsContainer },
  props: {
    errors: {
      type: Array as () => Errors,
      required: true,
    },
  },
  setup() {
    const { initPanelBuilder, configuration, setLoading } = usePanelBuilder()

    const router = useRouter()
    const route = useRoute()
    const { trackSignalStarStep } = useEcommerceAnalytics()
    const { t } = useI18n()

    const panelBuilderId = ref('')
    const targetSelected = ref<TargetSpecies | null>(configuration.value?.targetSpecies ?? null)

    const handleNextStep = async () => {
      if (!targetSelected.value) {
        console.warn('Target species was not selected')
        return
      }

      trackSignalStarStep('Target species')

      setLoading(true)
      try {
        initPanelBuilder(targetSelected.value)
        await router.push({
          path: '/products/signalstar/selectantibodies',
          query: route.value.query,
        })
      } finally {
        setLoading(false)
      }
    }

    const handleSubmitPanelBuilderId = () => {}

    return {
      handleNextStep,
      targetSelected,
      panelBuilderId,
      handleSubmitPanelBuilderId,
      t,
      targetOptions,
    }
  },
})
